import { Link } from "react-router-dom";
import { ArrowRight, MessageSquare } from "lucide-react";
import Reveal from "@/components/Reveal";
import { SMS_URL } from "@/config";

export default function APropos() {
  return (
    <div data-testid="a-propos-page">
      <section className="mx-auto grid max-w-7xl gap-14 px-6 py-20 md:grid-cols-[2fr_3fr] md:px-12 md:py-28">
        <Reveal>
          <img
            src="/juliette.webp"
            alt="Portrait de Juliette Maquestiau"
            data-testid="about-portrait"
            className="aspect-[3/4] w-full rounded-2xl object-cover"
          />
        </Reveal>

        <Reveal delay={0.1}>
          <p className="font-display text-xs tracking-[0.2em] uppercase text-taupe">À propos</p>
          <h1 className="mt-6 font-display text-4xl font-light leading-tight tracking-tight text-charcoal sm:text-5xl">
            Juliette Maquestiau
          </h1>
          <p className="mt-3 font-display text-lg text-stone-500">Une double posture : thérapeute et enseignante</p>

          <div className="mt-10 space-y-6 text-base leading-relaxed text-stone-700 max-w-prose">
            <p>
              J'accompagne les jeunes de 10 à 20 ans — et leurs parents — lorsque la scolarité ou
              la vie familiale devient un combat quotidien. Mon travail s'adresse aux adolescents
              et pré-adolescents qui vivent avec un TDAH, un haut potentiel, des troubles DYS, un
              TSA, une anxio-dépression ou une phobie scolaire.
            </p>
            <p>
              Je suis à la fois thérapeute et enseignante, deux dimensions qui se complètent
              profondément dans ma pratique. Mon métier de professeur constitue mon socle
              professionnel&nbsp;: il m'a permis de développer une connaissance fine du
              fonctionnement des jeunes, de leurs parcours scolaires, de leurs difficultés
              d'apprentissage, de leurs relations aux autres et de la manière dont leur vécu
              émotionnel peut influencer leur rapport à l'école.
            </p>
            <p>
              Aujourd'hui, je m'appuie sur cette expérience (développée dans différents types
              d'enseignements) dans le cadre de mes consultations thérapeutiques. Elle me permet
              de porter un regard à la fois clinique, neutre, éducatif et systémique sur les
              situations que je rencontre.
            </p>
            <p>
              Je tiens compte de l'adolescent, mais aussi de son environnement scolaire, familial
              et social.
            </p>
            <p>
              Je souhaite avant tout proposer un accompagnement bienveillant, accessible et
              personnalisé, dans lequel chacun peut se sentir écouté sans jugement. Pour moi,
              consulter ne signifie pas forcément que «&nbsp;quelque chose ne va pas&nbsp;»&nbsp;:
              c'est parfois simplement avoir besoin d'un espace pour comprendre ce que l'on
              traverse, retrouver ses ressources et être accompagné pour avancer.
            </p>
          </div>

          <div
            data-testid="about-bio-placeholder"
            className="mt-10 rounded-2xl border border-stone-200 bg-sand p-8"
          >
            <p className="font-display text-xs tracking-[0.2em] uppercase text-stone-500">Parcours</p>
            <p className="mt-4 text-base leading-relaxed text-stone-700">
              Professeure de Français, de Morale et de Philosophie et citoyenneté.
            </p>
            <p className="mt-2 text-base leading-relaxed text-stone-700">
              Thérapeute cognitive et comportementale (IPHM).
            </p>
          </div>

          <div className="mt-12 flex flex-wrap gap-4">
            <a
              href={SMS_URL}
              data-testid="about-agenda-cta"
              className="inline-flex items-center gap-2 rounded-full bg-taupe px-7 py-3 font-display text-sm text-bone transition-colors hover:bg-taupe-dark"
            >
              <MessageSquare size={16} /> Prendre rendez-vous par SMS
            </a>
            <Link
              to="/contact"
              data-testid="about-contact-cta"
              className="inline-flex items-center gap-2 rounded-full border border-taupe px-7 py-3 font-display text-sm text-taupe transition-colors hover:bg-taupe hover:text-bone"
            >
              Me contacter <ArrowRight size={16} />
            </Link>
          </div>
        </Reveal>
      </section>
    </div>
  );
}
